import _ from 'lodash'
import { HOUR_IN_MILLI } from './utils'

const getInitialState = (): any => ({
    events: {},
    data: {}
})

// const isBufferFullfield = (total = 0, layer, buffer) => {
//     const layerData = buffer[layer] || []

//     return layerData.length === total - 1
// }

export const reducer: WidgetReducerType<GMapsState, GMapsMessage> = (state = getInitialState(), message) => {
    const layer = message?.layer

    switch (message?.type) {
        case 'start': {
            return getInitialState()
        }
        case 'event': {
            const newState = {
                isLoading: false,
                data: {
                    [layer]: [...message.events] 
                }
            }

            return newState
        }
        default:
            return state
    }
}


// import _ from 'lodash'
// import { HOUR_IN_MILLI } from './utils'

// const getInitialState = (): GMapsState => ({
//     events: {},
//     data: {},
//     isTimeToUpdate: true,
//     isFirstLoad: true,
//     isLoading: true,
//     firstLoadTimestamp: 0,
//     currentBatchTimestamp: 0
// })

// // const isBufferFullfield = (total = 0, layer, buffer) => {
// //     const layerData = buffer[layer] || []

// //     return layerData.length === total - 1
// // }

// export const reducer: WidgetReducerType<GMapsState, GMapsMessage> = (state = getInitialState(), message) => {
//     const layer = message?.layer

//     switch (message?.type) {
//         case 'start': {
//             return getInitialState()
//         }
//         case 'event': {
//             let firstLoadTimestamp = state.firstLoadTimestamp,
//                 currentBatchTimestamp,
//                 isTimeToUpdate = false,
//                 isFirstLoad = state.isFirstLoad

//             if (layer === 0) {
//                 if (!state.firstLoadTimestamp && message.events[0]?.list) {
//                     firstLoadTimestamp = message.events[0]?.timestamp
//                 } else {
//                     isFirstLoad = false
//                     currentBatchTimestamp = message.events[0]?.timestamp
//                     if (currentBatchTimestamp - firstLoadTimestamp >= HOUR_IN_MILLI) {
//                         isTimeToUpdate = true
//                     }
//                 }
//             }
//             state = {
//                 ...state,
//                 data: {
//                     ...state.data,
//                     [layer]: layer <= 1 ? [...message.events[0]?.list] : [...message.events[0]?.perspectives]
//                 },
//                 isLoading: false,
//                 isTimeToUpdate,
//                 isFirstLoad,
//                 firstLoadTimestamp
//             }

//             break
//         }
//         default:
//             return state
//     }
//     return state
// }
